/*
 * FEVR Penalty Shootout - pixel art helpers (bitmap font, keeper sprites, ball, hearts).
 * Everything is drawn with fillRect on a 180x320 logical canvas, so there are no image files.
 */
(function () {
  'use strict';

  var INK = '#000000', WHITE = '#ffffff', GREY1 = '#9a9a9a', GREY2 = '#444444', GREY3 = '#1a1a1a';
  var NEON = '#ff6a00', CYAN = '#00f0ff', PINK = '#ff2bd6', RED = '#ff2a2a';

  /* ---------- 5x7 bitmap font ---------- */
  var GLYPHS = {
    'A': '.###. #...# #...# ##### #...# #...# #...#', 'B': '####. #...# #...# ####. #...# #...# ####.',
    'C': '.###. #...# #.... #.... #.... #...# .###.', 'D': '####. #...# #...# #...# #...# #...# ####.',
    'E': '##### #.... #.... ####. #.... #.... #####', 'F': '##### #.... #.... ####. #.... #.... #....',
    'G': '.###. #...# #.... #.### #...# #...# .###.', 'H': '#...# #...# #...# ##### #...# #...# #...#',
    'I': '.###. ..#.. ..#.. ..#.. ..#.. ..#.. .###.', 'J': '..### ...#. ...#. ...#. ...#. #..#. .##..',
    'K': '#...# #..#. #.#.. ##... #.#.. #..#. #...#', 'L': '#.... #.... #.... #.... #.... #.... #####',
    'M': '#...# ##.## #.#.# #.#.# #...# #...# #...#', 'N': '#...# ##..# #.#.# #..## #...# #...# #...#',
    'O': '.###. #...# #...# #...# #...# #...# .###.', 'P': '####. #...# #...# ####. #.... #.... #....',
    'Q': '.###. #...# #...# #...# #.#.# #..#. .##.#', 'R': '####. #...# #...# ####. #.#.. #..#. #...#',
    'S': '.#### #.... #.... .###. ....# ....# ####.', 'T': '##### ..#.. ..#.. ..#.. ..#.. ..#.. ..#..',
    'U': '#...# #...# #...# #...# #...# #...# .###.', 'V': '#...# #...# #...# #...# #...# .#.#. ..#..',
    'W': '#...# #...# #...# #.#.# #.#.# ##.## #...#', 'X': '#...# #...# .#.#. ..#.. .#.#. #...# #...#',
    'Y': '#...# #...# .#.#. ..#.. ..#.. ..#.. ..#..', 'Z': '##### ....# ...#. ..#.. .#... #.... #####',
    '0': '.###. #...# #..## #.#.# ##..# #...# .###.', '1': '..#.. .##.. ..#.. ..#.. ..#.. ..#.. .###.',
    '2': '.###. #...# ....# ...#. ..#.. .#... #####', '3': '####. ....# ....# .###. ....# ....# ####.',
    '4': '...#. ..##. .#.#. #..#. ##### ...#. ...#.', '5': '##### #.... ####. ....# ....# #...# .###.',
    '6': '.###. #.... #.... ####. #...# #...# .###.', '7': '##### ....# ...#. ..#.. .#... .#... .#...',
    '8': '.###. #...# #...# .###. #...# #...# .###.', '9': '.###. #...# #...# .#### ....# ....# .###.',
    '!': '..#.. ..#.. ..#.. ..#.. ..#.. ..... ..#..', '?': '.###. #...# ....# ...#. ..#.. ..... ..#..',
    '.': '..... ..... ..... ..... ..... .##.. .##..', ',': '..... ..... ..... ..... .##.. ..#.. .#...',
    ':': '..... .##.. .##.. ..... .##.. .##.. .....', '-': '..... ..... ..... ##### ..... ..... .....',
    '_': '..... ..... ..... ..... ..... ..... #####', "'": '..#.. ..#.. .#... ..... ..... ..... .....',
    '+': '..... ..#.. ..#.. ##### ..#.. ..#.. .....', '/': '....# ....# ...#. ..#.. .#... #.... #....',
    '%': '##..# ##..# ...#. ..#.. .#... #..## #..##', '(': '...#. ..#.. .#... .#... .#... ..#.. ...#.',
    ')': '.#... ..#.. ...#. ...#. ...#. ..#.. .#...', '>': '#.... .#... ..#.. ...#. ..#.. .#... #....',
    '<': '....# ...#. ..#.. .#... ..#.. ...#. ....#', '#': '.#.#. ##### .#.#. .#.#. ##### .#.#. .....',
    ' ': '..... ..... ..... ..... ..... ..... .....'
  };
  var GLYPH_ROWS = {};
  Object.keys(GLYPHS).forEach(function (ch) { GLYPH_ROWS[ch] = GLYPHS[ch].split(' '); });

  function textWidth(str, scale) { return str.length ? str.length * 6 * scale - scale : 0; }

  function drawText(ctx, str, x, y, scale, color, align, outline) {
    str = String(str).toUpperCase();
    var w = textWidth(str, scale);
    if (align === 'center') x = Math.round(x - w / 2);
    else if (align === 'right') x = Math.round(x - w);
    if (outline) {
      var o = scale;
      [[-o, 0], [o, 0], [0, -o], [0, o], [-o, -o], [o, o], [-o, o], [o, -o]].forEach(function (d) { glyphs(ctx, str, x + d[0], y + d[1], scale, outline); });
    }
    glyphs(ctx, str, x, y, scale, color);
    return w;
  }

  function glyphs(ctx, str, x, y, scale, color) {
    ctx.fillStyle = color;
    for (var i = 0; i < str.length; i++) {
      var rows = GLYPH_ROWS[str[i]] || GLYPH_ROWS['?'];
      var gx = x + i * 6 * scale;
      for (var r = 0; r < 7; r++) {
        var row = rows[r];
        for (var c = 0; c < 5; c++) if (row.charAt(c) === '#') ctx.fillRect(gx + c * scale, y + r * scale, scale, scale);
      }
    }
  }

  /* Greedy word wrap into lines of at most maxChars characters. */
  function wrap(str, maxChars) {
    var words = String(str).toUpperCase().split(' '), lines = [], cur = '';
    words.forEach(function (w) {
      if ((cur + ' ' + w).trim().length > maxChars) { if (cur) lines.push(cur); cur = w; } else cur = (cur + ' ' + w).trim();
    });
    if (cur) lines.push(cur);
    return lines;
  }

  /* ---------- hearts + ball ---------- */
  var HEART = ['.##.##.', '#######', '#######', '.#####.', '..###..', '...#...'];
  function drawHeart(ctx, x, y, color) {
    ctx.fillStyle = color;
    for (var r = 0; r < HEART.length; r++) for (var c = 0; c < 7; c++) if (HEART[r].charAt(c) === '#') ctx.fillRect(x + c, y + r, 1, 1);
  }
  function drawHeartOutline(ctx, x, y, color) {
    ctx.fillStyle = color;
    for (var r = 0; r < HEART.length; r++) for (var c = 0; c < 7; c++) {
      if (HEART[r].charAt(c) !== '#') continue;
      var edge = c === 0 || HEART[r].charAt(c - 1) !== '#' || c === 6 || HEART[r].charAt(c + 1) !== '#' || r === 0 || HEART[r - 1].charAt(c) !== '#' || r === HEART.length - 1 || HEART[r + 1].charAt(c) !== '#';
      if (edge) ctx.fillRect(x + c, y + r, 1, 1);
    }
  }

  function drawBall(ctx, cx, cy, r, spin) {
    cx = Math.round(cx); cy = Math.round(cy); r = Math.max(2, Math.round(r));
    function disc(rad, color) {
      ctx.fillStyle = color;
      for (var dy = -rad; dy <= rad; dy++) {
        var hw = Math.floor(Math.sqrt(rad * rad - dy * dy) + 0.5);
        ctx.fillRect(cx - hw, cy + dy, hw * 2 + 1, 1);
      }
    }
    disc(r + 1, INK);
    disc(r, WHITE);
    ctx.fillStyle = INK;
    if (r >= 3) {
      ctx.fillRect(cx - 1, cy - 1, 2, 2);
      for (var i = 0; i < 3; i++) {
        var a = spin + i * 2.094;
        ctx.fillRect(Math.round(cx + Math.cos(a) * r * 0.62) - 0, Math.round(cy + Math.sin(a) * r * 0.62) - 0, 1, 1);
      }
    } else ctx.fillRect(cx, cy, 1, 1);
  }

  /* ---------- keeper sprites ---------- */
  var LOOKS = {
    baby:         { skin: '#f2cfae', hair: '#c9a46a', hairStyle: 'tuft',   shirt: '#ffffff', shorts: '#e6e6e6', socks: '#ffffff', glove: CYAN, headW: 9, headH: 8, bodyW: 8, bodyH: 6, legH: 3, armLen: 5, extra: ['diaper', 'pacifier'] },
    gmac:         { skin: '#d9a37a', hair: '#111111', hairStyle: 'cap',    shirt: '#ffffff', shorts: '#111111', socks: '#ffffff', glove: NEON, headW: 6, headH: 6, bodyW: 8, bodyH: 8, legH: 7, armLen: 7, extra: [] },
    sunday:       { skin: '#e8b894', hair: '#6b3b1c', hairStyle: 'mess',   shirt: '#bdbdbd', shorts: '#2a2a2a', socks: '#8a8a8a', glove: '#ffe600', headW: 6, headH: 6, bodyW: 10, bodyH: 9, legH: 7, armLen: 7, extra: ['belly', 'stubble'] },
    nonleague:    { skin: '#c98e65', hair: '#111111', hairStyle: 'beanie', shirt: '#d0d0d0', shorts: '#000000', socks: '#d0d0d0', glove: PINK, headW: 6, headH: 6, bodyW: 8, bodyH: 8, legH: 8, armLen: 8, extra: [] },
    championship: { skin: '#8d5a3b', hair: '#000000', hairStyle: 'short',  shirt: '#ffffff', shorts: '#ffffff', socks: '#ffffff', glove: CYAN, headW: 6, headH: 6, bodyW: 8, bodyH: 9, legH: 8, armLen: 8, extra: ['headband', 'stripes'] },
    premier:      { skin: '#f0c8a0', hair: '#d8b45a', hairStyle: 'sleek',  shirt: '#161616', shorts: '#161616', socks: '#161616', glove: NEON, headW: 6, headH: 6, bodyW: 8, bodyH: 9, legH: 9, armLen: 9, extra: ['collar'] },
    courtois:     { skin: '#e8b894', hair: '#3a2412', hairStyle: 'short',  shirt: '#ececec', shorts: '#111111', socks: '#111111', glove: PINK, headW: 8, headH: 9, bodyW: 12, bodyH: 20, legH: 30, armLen: 21, gloveW: 6, gloveH: 5, extra: ['tall'] },
    octopus:      { skin: PINK, hair: PINK, hairStyle: 'none', shirt: PINK, shorts: PINK, socks: PINK, glove: '#ffffff', headW: 12, headH: 10, bodyW: 8, bodyH: 2, legH: 2, armLen: 12, extra: ['octopus'] },
    robo:         { skin: '#9aa0a6', hair: '#9aa0a6', hairStyle: 'none', shirt: '#c8c8c8', shorts: '#6a6f75', socks: '#9aa0a6', glove: CYAN, headW: 7, headH: 6, bodyW: 10, bodyH: 10, legH: 9, armLen: 10, gloveW: 5, gloveH: 4, extra: ['visor', 'antenna', 'rivets'] },
    'void':       { skin: '#050505', hair: '#050505', hairStyle: 'none', shirt: '#050505', shorts: '#050505', socks: '#050505', glove: '#050505', headW: 7, headH: 7, bodyW: 10, bodyH: 11, legH: 11, armLen: 12, gloveW: 5, gloveH: 4, extra: ['neoneyes', 'outline'] }
  };

  var SPR_W = 52, SPR_H = 84;

  /* GMAC: hand-drawn to match the FEVR look (printed city beanie, locs, silver-panel track jacket, black piped pants, chunky silver trainers). */
  function buildGmac(frame) {
    var cv = document.createElement('canvas');
    cv.width = SPR_W; cv.height = SPR_H;
    var g = cv.getContext('2d');
    function r(x, y, w, h, c) { g.fillStyle = c; g.fillRect(x, y, w, h); }
    var SKIN = '#6a4430', SKIN_D = '#55331f', LOC = '#33200f', LOC_H = '#52371f';
    var JK = '#0d0d0d', JK_H = '#1d1d1d', SILV = '#b4bdc8', SILV_D = '#8b95a2', PIPE = '#f2f2f2', BLUE = '#2c6fe0';
    var cx = 26;

    // locs behind the head, falling past the shoulders
    r(20, 27, 13, 2, LOC);
    r(20, 29, 2, 9, LOC); r(31, 29, 2, 9, LOC);
    for (var ly = 29; ly < 38; ly += 2) { r(20, ly, 1, 1, LOC_H); r(32, ly + 1, 1, 1, LOC_H); }
    // beanie: printed city scene (sky -> buildings) with a pale cuff
    r(23, 22, 7, 1, '#7bb8ea');
    ['#7bb8ea', '#9fcdf0', '#7bb8ea', '#d7e8f5', '#7bb8ea', '#9fcdf0', '#7bb8ea', '#d7e8f5', '#7bb8ea'].forEach(function (c, i) { r(22 + i, 23, 1, 1, c); });
    ['#c8622d', '#8a8f99', '#d7d9de', '#5a3a30', '#c8622d', '#e08a4a', '#8a8f99', '#5a3a30', '#c8622d', '#d7d9de', '#8a8f99'].forEach(function (c, i) { r(21 + i, 24, 1, 1, c); });
    ['#5a3a30', '#c8622d', '#8a8f99', '#c8622d', '#d7d9de', '#5a3a30', '#e08a4a', '#8a8f99', '#c8622d', '#5a3a30', '#d7d9de'].forEach(function (c, i) { r(21 + i, 25, 1, 1, c); });
    for (var bi = 0; bi < 11; bi++) r(21 + bi, 26, 1, 1, bi % 2 ? '#c9ced6' : '#e6e9ee');
    // face
    r(22, 27, 8, 7, SKIN);
    r(22, 32, 8, 2, SKIN_D);
    r(23, 28, 3, 1, '#1f130d'); r(27, 28, 3, 1, '#1f130d');           // brows
    r(24, 29, 1, 1, '#120a06'); r(28, 29, 1, 1, '#120a06');           // eyes
    r(26, 30, 1, 1, '#3d261a');                                       // nose
    if (frame === 1) r(25, 32, 2, 1, '#120a06'); else r(25, 32, 2, 1, '#2a1810');   // mouth (open when stretching)
    r(24, 33, 4, 1, '#1f130d');                                       // goatee
    // neck + tee collar
    r(24, 34, 4, 1, SKIN_D);
    r(23, 35, 6, 1, '#ffffff');

    // jacket body
    r(19, 35, 14, 8, JK);
    r(22, 35, 8, 1, JK_H);
    r(21, 36, 10, 6, SILV);                                           // silver chest panel
    for (var sx = 22; sx < 31; sx += 2) r(sx, 36, 1, 3, SILV_D);      // print stripes
    for (var dx = 22; dx < 31; dx += 3) r(dx, 40, 1, 1, SILV_D);      // dots
    r(25, 35, 1, 8, '#1b1b1b'); r(26, 36, 1, 6, '#4a4f57');            // zip
    r(24, 35, 4, 1, '#ffffff');                                       // tee V
    r(20, 35, 3, 1, PIPE); r(29, 35, 3, 1, PIPE);                     // shoulder piping
    r(19, 42, 14, 1, '#050505');                                      // elastic hem
    r(19, 43, 14, 1, BLUE);                                           // blue waistband peeking out

    // arms (black sleeves, FEVR-orange gloves)
    function arm(left) {
      var sx2 = left ? 16 : 33;
      if (frame === 1) {
        r(sx2, 24, 3, 13, JK); r(sx2 + (left ? 2 : 0), 24, 1, 13, JK_H);
        r(left ? sx2 : sx2 + 2, 35, 1, 1, PIPE);
        r(sx2 - 1, 19, 5, 5, '#ff6a00'); r(sx2 - 1, 19, 5, 1, '#ff9a4d');
      } else {
        r(sx2, 36, 3, 10, JK); r(sx2, 45, 3, 1, '#050505');
        r(left ? sx2 : sx2 + 2, 36, 1, 1, PIPE);
        r(sx2 - 1, 46, 5, 4, '#ff6a00'); r(sx2 - 1, 46, 5, 1, '#ff9a4d');
      }
    }
    arm(true); arm(false);

    // baggy pants with white side piping
    r(19, 44, 14, 3, '#0a0a0a');
    [18, 27].forEach(function (lx, i) {
      r(lx, 47, 7, 11, '#0a0a0a');
      r(lx + (i ? 5 : 1), 47, 1, 11, PIPE);                           // piping runs down the outer seam
      r(lx + (i ? 2 : 4), 47, 1, 11, '#161616');                      // fold
      r(lx, 56, 7, 1, '#1f1f1f');                                     // hem
    });
    r(20, 45, 12, 1, '#1a1a1a');
    // chunky silver trainers with a lime sole
    [16, 27].forEach(function (fx, i) {
      r(fx, 58, 9, 2, '#cfd4db'); r(fx + (i ? 0 : 6), 58, 3, 1, '#ffffff');
      r(fx + (i ? 7 : 0), 58, 2, 2, '#9aa1ab');
      r(fx, 60, 9, 1, '#c3d43a');
    });

    var tipY = frame === 1 ? 19 : 36;
    return { cv: cv, px: cx, py: 39, fy: 61, tip: frame === 1 ? 39 - tipY : 4 };
  }

  /* Builds one keeper pose on an offscreen canvas. frame 0 = ready stance, 1 = full stretch. */
  function buildKeeperSprite(id, frame) {
    if (id === 'gmac') return buildGmac(frame);
    var L = LOOKS[id];
    var cv = document.createElement('canvas');
    cv.width = SPR_W; cv.height = SPR_H;
    var g = cv.getContext('2d');
    function r(x, y, w, h, c) { g.fillStyle = c; g.fillRect(Math.round(x), Math.round(y), w, h); }
    var has = function (e) { return L.extra.indexOf(e) !== -1; };

    var cx = 26, feet = SPR_H - 4;
    var legTop = feet - L.legH;
    var shortsTop = legTop - 3;
    var torsoTop = shortsTop - L.bodyH + 1;
    var shoulderY = torsoTop + 1;
    var headTop = torsoTop - L.headH + 2;
    var bw = L.bodyW, bx = cx - Math.floor(bw / 2);
    var hl = cx - Math.floor(L.headW / 2);
    var gw = L.gloveW || 4, gh = L.gloveH || 3;
    var tipY = shoulderY;

    if (has('octopus')) {
      // big round head, 8 wavy tentacles; in stretch they fan upward
      var hx = cx - 7;
      var topY = torsoTop - 6;
      [[hx + 2, topY, 10, 1], [hx, topY + 1, 14, 1], [hx - 1, topY + 2, 16, 8], [hx, topY + 10, 14, 1], [hx + 1, topY + 11, 12, 1]].forEach(function (q) { r(q[0], q[1], q[2], q[3], PINK); });
      r(hx + 3, topY + 4, 3, 3, WHITE); r(hx + 9, topY + 4, 3, 3, WHITE);
      r(hx + 4, topY + 5, 1, 2, INK); r(hx + 10, topY + 5, 1, 2, INK);
      var baseY = topY + 12;
      if (frame === 0) {
        for (var i = 0; i < 8; i++) {
          var tx = hx - 3 + i * 3 + (i > 3 ? 1 : 0), wob = (i % 2) * 2;
          r(tx, baseY, 2, 4 + wob, PINK); r(tx + (i < 4 ? -1 : 1), baseY + 4 + wob, 2, 3, PINK);
        }
        for (var j = 0; j < 8; j++) r(hx - 2 + j * 2.2, baseY + 8, 1, 1, WHITE); // suckers
      } else {
        // four arms up each side
        for (var k = 0; k < 4; k++) {
          r(hx - 2 - k * 2, topY - 2 - k * 3 + 6, 2, 10, PINK); r(hx - 4 - k * 2, topY - 6 - k * 3 + 6, 2, 5, PINK);
          r(hx + 14 + k * 2, topY - 2 - k * 3 + 6, 2, 10, PINK); r(hx + 16 + k * 2, topY - 6 - k * 3 + 6, 2, 5, PINK);
        }
        for (var m = 0; m < 6; m++) r(hx + 1 + m * 2, baseY, 2, 5, PINK);
      }
      tipY = frame === 1 ? topY - 8 : topY;
      return finish(cx, topY + 6, baseY + 10, tipY);
    }

    // legs
    [cx - 4, cx + 1].forEach(function (lx) {
      r(lx, legTop, 3, L.legH, L.skin);
      r(lx, legTop + Math.floor(L.legH * 0.45), 3, Math.ceil(L.legH * 0.55), L.socks);
      r(lx - 1, feet - 1, 5, 2, id === 'void' ? '#050505' : '#111111');
    });
    if (id === 'robo') { r(cx - 4, legTop, 3, 2, '#6a6f75'); r(cx + 1, legTop, 3, 2, '#6a6f75'); }
    // shorts / diaper
    if (has('diaper')) { r(bx - 1, shortsTop, bw + 2, 5, '#f4f4f4'); r(cx - 1, shortsTop, 2, 2, PINK); }
    else r(bx, shortsTop, bw, 4, L.shorts);
    // torso
    r(bx, torsoTop, bw, L.bodyH, L.shirt);
    if (has('belly')) { r(bx - 1, torsoTop + L.bodyH - 6, bw + 2, 6, L.shirt); r(bx + 1, torsoTop + L.bodyH - 4, bw - 2, 1, '#9a9a9a'); }
    if (has('stripes')) for (var s = 1; s < bw; s += 2) r(bx + s, torsoTop, 1, L.bodyH, '#000000');
    if (has('collar')) { r(cx - 2, torsoTop, 4, 1, WHITE); r(bx, torsoTop + L.bodyH - 1, bw, 1, WHITE); }
    if (has('rivets')) { r(bx + 1, torsoTop + 2, 1, 1, CYAN); r(bx + bw - 2, torsoTop + 2, 1, 1, CYAN); r(cx - 1, torsoTop + 4, 2, 2, CYAN); }
    if (id === 'void') r(cx - 1, torsoTop + 3, 2, 2, NEON);
    // arms
    var armOffL = Math.min(bx - 1, hl - 2), armOffR = Math.max(bx + bw - 1, hl + L.headW);
    function arm(x, up, left) {
      if (up) {
        r(x, shoulderY - L.armLen + 2, 2, L.armLen, L.skin);
        r(x, shoulderY - 1, 2, 3, L.shirt);
        r(left ? x - 1 : x - 1, shoulderY - L.armLen + 2 - gh, gw, gh, L.glove);
      } else {
        var ox = left ? bx - 3 : bx + bw + 1;
        r(ox, shoulderY, 2, 3, L.shirt);
        r(ox + (left ? -1 : 1), shoulderY + 3, 2, L.armLen - 3, L.skin);
        r(ox + (left ? -2 : 0), shoulderY + L.armLen - 1, gw, gh, L.glove);
      }
    }
    if (frame === 1) { arm(armOffL, true, true); arm(armOffR, true, false); tipY = shoulderY - L.armLen + 2 - gh; }
    else { arm(0, false, true); arm(0, false, false); tipY = shoulderY; }
    // head
    r(hl, headTop, L.headW, L.headH, L.skin);
    // hair / hats
    switch (L.hairStyle) {
      case 'short': r(hl, headTop, L.headW, 2, L.hair); break;
      case 'tuft': r(cx - 1, headTop - 2, 2, 2, L.hair); r(hl, headTop, L.headW, 1, L.hair); break;
      case 'mess': r(hl - 1, headTop - 1, L.headW + 2, 3, L.hair); r(hl - 1, headTop + 2, 1, 2, L.hair); r(hl + L.headW, headTop + 2, 1, 2, L.hair); r(cx, headTop - 2, 1, 1, L.hair); break;
      case 'cap': r(hl - 1, headTop - 1, L.headW + 2, 3, WHITE); r(hl - 3, headTop + 1, 4, 1, WHITE); r(cx - 1, headTop, 2, 1, INK); break;
      case 'beanie': r(hl, headTop - 2, L.headW, 4, '#555555'); r(cx - 1, headTop - 4, 2, 2, WHITE); r(hl, headTop, L.headW, 1, '#8a8a8a'); break;
      case 'sleek': r(hl, headTop, L.headW, 2, L.hair); r(hl - 1, headTop + 1, 1, 3, L.hair); break;
      default: break;
    }
    if (has('headband')) r(hl, headTop + 2, L.headW, 1, WHITE);
    // face
    var eyeY = headTop + Math.floor(L.headH / 2);
    if (has('visor')) { r(hl + 1, eyeY - 1, L.headW - 2, 2, CYAN); }
    else if (has('neoneyes')) { r(hl + 1, eyeY, 2, 1, NEON); r(hl + L.headW - 3, eyeY, 2, 1, NEON); }
    else { r(hl + 1 + (L.headW > 7 ? 1 : 0), eyeY, 1, 1, INK); r(hl + L.headW - 2 - (L.headW > 7 ? 1 : 0), eyeY, 1, 1, INK); }
    if (has('stubble')) r(hl + 1, headTop + L.headH - 2, L.headW - 2, 2, '#6a5a50');
    if (has('pacifier')) { r(cx - 1, headTop + L.headH - 3, 3, 2, PINK); r(cx, headTop + L.headH - 1, 1, 1, WHITE); }
    if (has('antenna')) { r(cx, headTop - 4, 1, 4, '#cccccc'); r(cx - 1, headTop - 5, 3, 1, CYAN); }
    if (frame === 1 && id !== 'octopus') { /* mouth open */ r(cx, headTop + L.headH - 2, 1, 1, INK); }

    return finish(cx, torsoTop + Math.floor(L.bodyH / 2), feet, tipY);

    function finish(px, py, fy, tip) {
      if (has('outline')) outline(g);
      return { cv: cv, px: px, py: py, fy: fy, tip: Math.max(4, py - tip) };
    }
  }

  /* 1px white outline around every opaque pixel (used for the final boss). */
  function outline(g) {
    var img = g.getImageData(0, 0, SPR_W, SPR_H), d = img.data, out = new Uint8ClampedArray(d);
    function a(x, y) { return x < 0 || y < 0 || x >= SPR_W || y >= SPR_H ? 0 : d[(y * SPR_W + x) * 4 + 3]; }
    for (var y = 0; y < SPR_H; y++) for (var x = 0; x < SPR_W; x++) {
      if (a(x, y) === 0 && (a(x - 1, y) || a(x + 1, y) || a(x, y - 1) || a(x, y + 1))) {
        var i = (y * SPR_W + x) * 4; out[i] = 255; out[i + 1] = 255; out[i + 2] = 255; out[i + 3] = 255;
      }
    }
    img.data.set(out); g.putImageData(img, 0, 0);
  }

  window.FevrArt = {
    INK: INK, WHITE: WHITE, GREY1: GREY1, GREY2: GREY2, GREY3: GREY3, NEON: NEON, CYAN: CYAN, PINK: PINK, RED: RED,
    drawText: drawText, textWidth: textWidth, wrap: wrap,
    drawHeart: drawHeart, drawHeartOutline: drawHeartOutline, drawBall: drawBall,
    buildKeeperSprite: buildKeeperSprite, LOOKS: LOOKS
  };
})();
